import Vue from 'vue'

export default Vue.extend({
  name: 'VersionDialog',
  props: {
    show: Boolean,
    title: {
      type: String,
      default: 'システムが更新されました'
    },
    description: {
      type: String,
      default: 'ページを更新しますと、最新機能をご利用頂けます。'
    },
    confirm: {
      type: String,
      default: '更新する'
    },
    confirmColor: {
      type: String,
      default: 'green'
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },

    submit () {
      this.$emit('submit')
      this.close()
    }
  }
})
